/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyArticleInfo,
    JsonEventPartyArticleInfoFromJSON,
    JsonEventPartyArticleInfoFromJSONTyped,
    JsonEventPartyArticleInfoToJSON,
} from './JsonEventPartyArticleInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventPartyArticleInfo
 */
export interface ApiResultOfJsonEventPartyArticleInfo {
    /**
     * 
     * @type {JsonEventPartyArticleInfo}
     * @memberof ApiResultOfJsonEventPartyArticleInfo
     */
    data?: JsonEventPartyArticleInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyArticleInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventPartyArticleInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyArticleInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyArticleInfo
     */
    result?: ApiResultOfJsonEventPartyArticleInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventPartyArticleInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventPartyArticleInfoFromJSON(json: any): ApiResultOfJsonEventPartyArticleInfo {
    return ApiResultOfJsonEventPartyArticleInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventPartyArticleInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventPartyArticleInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventPartyArticleInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventPartyArticleInfoToJSON(value?: ApiResultOfJsonEventPartyArticleInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventPartyArticleInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

